export const iconFontAwesomeHalloweenSpider = (
	<i className="fa-solid fa-spider"></i>
);
